const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_minimal/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";

/**
 * Pathless layout segment for full-screen experiences (the Live room today;
 * iframe embeds and shared-post views next). Routes nested here own their own
 * chrome: `MainAppContent` detects the `/_minimal` segment and skips the
 * member-area AppShell, top banners, cookie banner, and help widget entirely —
 * the shell never mounts, so there is nothing to bypass at runtime.
 *
 * This is the end-state replacement for `useShellBypass`/`DynamicLayout`. As
 * each full-screen route migrates under this segment, its runtime bypass code
 * can be deleted.
 */

export const Route = createFileRoute("/_minimal")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});